import { createI18n } from 'vue-i18n';
import { getLanguage } from '@/lang/utils';
import zh from '@/lang/zh/zh';
import en from '@/lang/en/en';

const message = {
  zh,
  en,
};

const i18n = createI18n({
  locale: getLanguage(),
  legacy: false,
  globalInjection: true,
  messages: message,
});

export default i18n;
